import { Component, computed, input, output } from '@angular/core';

export interface Step {
  active: boolean;
  label?: string;
}

@Component({
  selector: 'app-stepper',
  standalone: true,
  imports: [],
  templateUrl: './stepper.component.html',
  styleUrl: './stepper.component.scss'
})
export class StepperComponent {
  steps = input<Step[]>();
  stepClicked = output<number>();

  activeStepIndex = computed(() => this.steps().findIndex((step) => step.active));
}
